"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentSelection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const buttons_1 = require("../../atoms/buttons");
const styled_components_1 = __importDefault(require("styled-components"));
const notification_1 = require("../../molecules/notification");
const EnvironmentSelection = (props) => {
    const [optionSelected, setOptionSelected] = (0, react_1.useState)("defaultSelectValue");
    const onChangeHandler = (e) => {
        setOptionSelected(e.target.value);
    };
    const onSubmitHandler = () => {
        if (optionSelected === "defaultSelectValue")
            return;
        props.setEnvironment(optionSelected);
    };
    return ((0, jsx_runtime_1.jsxs)(EnvironmentListWrapper, { className: props.className, children: [(0, jsx_runtime_1.jsx)(EnvironmentListContainer, { children: (0, jsx_runtime_1.jsxs)(EnvSelect, { "data-cy": "environment-select", onChange: onChangeHandler, value: optionSelected, children: [(0, jsx_runtime_1.jsx)(EnvSelectOption, { value: "defaultSelectValue", children: props.defaultSelectValue }, void 0), props.environments.map(({ endpoint, name }) => ((0, jsx_runtime_1.jsx)(EnvSelectOption, { value: endpoint, children: name }, endpoint)))] }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(EnvironmentListContainer, { children: (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", "data-cy": "environment-button", onClick: onSubmitHandler, children: props.buttonLabel }, void 0) }, void 0), props.predicateVPN && ((0, jsx_runtime_1.jsx)(NotificationWrapper, { children: (0, jsx_runtime_1.jsx)(notification_1.Notification, { content: "Turn on VPN, request is pending", isSuccess: true }, void 0) }, void 0))] }, void 0));
};
exports.EnvironmentSelection = EnvironmentSelection;
const NotificationWrapper = styled_components_1.default.div `
  margin-top: 40px;
`;
const EnvironmentListContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;
const EnvironmentListWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 122px;
  overflow: hidden;
`;
const EnvSelect = styled_components_1.default.select `
  align-items: center;
  background: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: 0;
  color: ${({ theme }) => theme.colors.greyLighten70};
  display: flex;
  font-size: 1rem;
  font-weight: normal;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacings.xs} 2rem ${theme.spacings.xs}  ${theme.spacings.m}`};
  text-overflow: ellipsis;
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;
const EnvSelectOption = styled_components_1.default.option `
  margin: 0;
  padding: 0;
`;
//# sourceMappingURL=EnvironmentSelection.js.map